module.exports = __webpack_public_path__ + "static/CIW_Part4-2dcb1c062965e4aae8bd946e54850248.pdf";